module.exports = __webpack_public_path__ + "static/media/veniTeo1.87aa23ca.jpeg";